import React, { PureComponent } from "react";
import CKEditor from "react-ckeditor-component";

class Editor extends PureComponent {
    state = {};
    render() {
        return (
            <CKEditor
                activeClass="p10"
                config={{
                    toolbar: [
                        { name: "document", items: ["Source"] },
                        { name: "basicstyles", items: ["Bold", "Italic"] },
                        { name: "clipboard", items: ["Cut", "Copy", "Paste"] },
                    ],
                    allowedContent: true,
                    removeFormatAttributes: "",
                }}
                content={this.props.content}
                events={{
                    change: (e) => this.props.onChange(e),
                }}
            />
        );
    }
}

export default Editor;
